<div class="row feedback-chat">
  <div class="m-b-25 head-component">
    <div class="col-10 p-l-20 m-0 br-0 for-fixed-component head-component card">
      <div class="col-9 pl-0 card-body">
        <div class="float-left">
          <h5 class="m-0 head-main-component">
            {{ "lang.userMenu.myFeedback" | translate }}
          </h5>
          <div class="filter">
            <span
              [class.filter-active]="!isAnonymousVisible"
              (click)="showAnonymous(false)"
            >
              {{ "lang.common.nonAnonymous" | translate }}
            </span>
            <span
              [class.filter-active]="isAnonymousVisible"
              (click)="showAnonymous(true)"
            >
              {{ "lang.common.anonymous" | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-9 p-l-25 mb-2 posclass">
    <app-feedback-chat-body
      [senderId]="senderId"
      [isAnonymousVisible]="isAnonymousVisible"
      [isOpenedByPm]="false"
      [events]="eventSubject.asObservable()"
    >
    </app-feedback-chat-body>
  </div>
  <div class="col-3 p-l-10 right-block">
    <div class="card bg-none pl-0 mb-2">
      <div class="card-body p-0">
        <div class="row info-panel">
          <div class="col-1">
            <i class="mdi mdi-information-outline"></i>
          </div>
          <div class="col-10 pr-0">
            <div class="helpInfo">
              {{ "lang.chat.help.general" | translate }}
            </div>
            <div class="helpInfo">
              {{ "lang.chat.help.search" | translate }}
            </div>
            <div class="helpInfo">{{ "lang.chat.help.tips" | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card phrases-card p-l-10 mb-2">
      <div class="card-body p-0">
        <div class="row header-panel py-2">
          <div class="col-11">
            {{ "lang.feedback.startConversation.header" | translate }}
          </div>
        </div>
        <div class="phrases-container">
          <div
            class="row phrase-panel"
            *ngFor="
              let phrase of 'lang.feedback.startConversation.phrases'
                | translate
            "
            (click)="selectPhrase(phrase)"
          >
            <div class="col-11">
              {{ phrase }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grow-container"></div>
    <app-links-card
      [links]="'lang.links.documents.my_feedback_chat' | translate"
    ></app-links-card>
  </div>
</div>
